import React from 'react';
import Icon from '../ui/Icon';

/* Granica błędów dla panelu admina. Pojedynczy błąd renderowania (np. .map na
   nie-tablicy z błędnej odpowiedzi API) nie może już wywracać całej aplikacji do
   białego ekranu — pokazujemy komunikat i pozwalamy wrócić/odświeżyć. Resetuje
   się przy zmianie trasy (resetKey), więc nawigacja zawsze działa. */

type Props = { children: React.ReactNode; resetKey?: string };
type State = { error: Error | null };

export default class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidUpdate(prev: Props) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="page">
        <div className="card" style={{ maxWidth: 640, margin: '48px auto', padding: 32, textAlign: 'center' }}>
          <div style={{ width: 56, height: 56, borderRadius: 14, background: 'var(--danger-soft, #fdecec)', color: 'var(--danger-text, #c0392b)', display: 'grid', placeItems: 'center', margin: '0 auto 16px' }}>
            <Icon name="alert-triangle" size={26} />
          </div>
          <h2 style={{ margin: '0 0 8px' }}>Coś poszło nie tak na tym ekranie</h2>
          <p className="muted" style={{ marginBottom: 18 }}>
            Wystąpił błąd podczas wyświetlania tego widoku. Reszta panelu działa —
            możesz spróbować ponownie lub wrócić do pulpitu.
          </p>
          <pre style={{ textAlign: 'left', background: 'var(--surface-3, #f5f6f8)', color: 'var(--fg-2, #555)', padding: 12, borderRadius: 10, fontSize: 12, overflow: 'auto', maxHeight: 160, marginBottom: 18 }}>
            {String(error?.message || error)}
          </pre>
          <div className="flex" style={{ justifyContent: 'center', gap: 10 }}>
            <button className="btn btn-ghost" onClick={() => this.setState({ error: null })}>Spróbuj ponownie</button>
            <button className="btn btn-primary" onClick={() => { window.location.href = '/'; }}>Wróć do pulpitu</button>
          </div>
        </div>
      </div>
    );
  }
}
